import React, { useEffect, useState } from "react";
import axios from "axios";

import NavBreadcrumb from "components/NavBreadcrumb";
import RecipeRating from "components/RecipeRating";
import ShareSocial from "components/ShareSocial";

import Typography from "@mui/material/Typography";
import Container from "@mui/material/Container";
import Box from "@mui/material/Box";
import Stack from "@mui/material/Stack";
import List from "@mui/material/List";
import ListItem from "@mui/material/ListItem";
import ListItemIcon from "@mui/material/ListItemIcon";
import ListItemText from "@mui/material/ListItemText";
import SellIcon from "@mui/icons-material/Sell";
import TimerIcon from "@mui/icons-material/Timer";
import PeopleIcon from "@mui/icons-material/People";
import CalculateIcon from "@mui/icons-material/Calculate";
import SetMealIcon from "@mui/icons-material/SetMeal";
import RestaurantIcon from "@mui/icons-material/Restaurant";
import SpeedIcon from "@mui/icons-material/Speed";
import RestaurantMenuIcon from "@mui/icons-material/RestaurantMenu";
import MenuBookIcon from "@mui/icons-material/MenuBook";

function RecipeDetails({ id }) {
  // Define initial state
  const [recipe, setRecipe] = useState("");

  useEffect(() => {
    // Get individual recipe from Express server
    const getRecipe = async function() {
      await axios.get("/food-recipe-react/api/recipes/" + id)
        .then(response => {
          setRecipe(response.data);
        })
        .catch(error => {
          console.log(error);
        });
    };
    
    getRecipe();
    window.scrollTo(0, 0); // scroll to top of page on page load
  }, [id]);

  // Define variables to display recipe details
  const recipeID = recipe.id;
  const recipeURL = "/recipes/" + recipeID;
  const imageURL = recipe.image;
  const name = recipe.name;
  const rating = recipe.rating;
  const tags = (recipe.tags && recipe.tags.join(", "));
  const imageURLCode = "url('" + imageURL + "')";
  const prepTime = "Prep Time: " + recipe.prepTimeMinutes + " Mins";
  const cookingTime = "Cooking Time: " + recipe.cookTimeMinutes + " Mins";
  const servings = recipe.servings + " Servings";
  const calories = recipe.caloriesPerServing + " Calories per Serving";
  const cuisine = recipe.cuisine;
  const mealType = (recipe.mealType && recipe.mealType.join(", "));
  const difficulty = recipe.difficulty;
  
  const ingredients = recipe.ingredients;
  const arrayIngredients = (ingredients && ingredients.map((ingredient) => 
    <ListItem key={ingredient} disablePadding>
      <ListItemIcon>
        <RestaurantMenuIcon fontSize="small" />
      </ListItemIcon>
      <ListItemText primary={ingredient} />
    </ListItem>
  ));

  const instructions = recipe.instructions;
  const arrayInstructions = (instructions && instructions.map((instruction) => 
    <ListItem key={instruction} disablePadding>
      <ListItemIcon>
        <MenuBookIcon fontSize="small" />
      </ListItemIcon>
      <ListItemText primary={instruction} />
    </ListItem>
  ));

  return (
    <>
      <Container maxWidth="sm">
        {/* NavBreadcrumb component */}
        <NavBreadcrumb cuisine={cuisine} />
        <Typography variant="h4">
          {name}
        </Typography>
        {/* RecipeRating component */}
        <RecipeRating rating={rating} />
        <Stack direction="row" alignItems="center" spacing={0.5} mt={1}>
          <SellIcon fontSize="small" color="info" />
          <Typography variant="body2" color="text.secondary">
            {tags}
          </Typography>
        </Stack>
        {/* ShareSocial component */}
        <ShareSocial recipeURL={recipeURL} imageURL={imageURL} name={name} />
        <Box 
          sx={{ 
            backgroundImage: imageURLCode,
            backgroundRepeat: "no-repeat",
            backgroundSize: "cover",
            height: "300px",
            width: "300px",
            my: 3
          }}
        >
        </Box>
        <List sx={{ my: 3 }}>
          <ListItem disablePadding>
            <ListItemIcon>
              <TimerIcon fontSize="small" />
            </ListItemIcon>
            <ListItemText primary={prepTime} />
          </ListItem>
          <ListItem disablePadding>
            <ListItemIcon>
              <TimerIcon fontSize="small" />
            </ListItemIcon>
            <ListItemText primary={cookingTime} />
          </ListItem>
          <ListItem disablePadding>
            <ListItemIcon>
              <PeopleIcon fontSize="small" />
            </ListItemIcon>
            <ListItemText primary={servings} />
          </ListItem>
          <ListItem disablePadding>
            <ListItemIcon>
              <CalculateIcon fontSize="small" />
            </ListItemIcon>
            <ListItemText primary={calories} />
          </ListItem>
          <ListItem disablePadding>
            <ListItemIcon>
              <SetMealIcon fontSize="small" />
            </ListItemIcon>
            <ListItemText primary={cuisine} />
          </ListItem>
          <ListItem disablePadding>
            <ListItemIcon>
              <RestaurantIcon fontSize="small" />
            </ListItemIcon>
            <ListItemText primary={mealType} />
          </ListItem>
          <ListItem disablePadding>
            <ListItemIcon>
              <SpeedIcon fontSize="small" />
            </ListItemIcon>
            <ListItemText primary={difficulty} />
          </ListItem>
        </List>
        <Typography variant="h5">
          Ingredients
        </Typography>
        <List sx={{ mb: 3 }}>
          {arrayIngredients}
        </List>
        <Typography variant="h5">
          Instructions
        </Typography>
        <List sx={{ mb: 3 }}>
          {arrayInstructions}
        </List>
      </Container>
    </>
  );
}
  
export default RecipeDetails;